import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '../../../services/customer.service';
import { LocalizationService } from 'shared/src/localization/public_api';
import { SelectGroupComponent } from '../select-group/select-group.component';
import { AdvMessageService } from 'shared/src/public-api';

@Component({
  selector: 'menu-group-list',
  templateUrl: './menu-group-list.component.html',
  styleUrls: ['./menu-group-list.component.scss']
})
export class MenuGroupListComponent extends SelectGroupComponent implements OnInit {

  constructor(customerService: CustomerService,localizationService: LocalizationService) {
      super(customerService, localizationService);
  }
  @Input() companyGroups: any[] = []; // Add this line
  @Output() selectedGroupChange = new EventEmitter<string>(); //
  ngOnInit(): void {
    const exists = this.companyGroups.some(group => group?.name?.trim() === 'ללא קבוצה');
    if (!exists) {
      this.addGroup();
    }
  }
  
  selectGroup(groupName: string) {
    this.selectedGroup = groupName;
    this.selectedGroupChange.emit(groupName); 
  }
  addGroup() {
    this.companyGroups.push({ id: (this.companyGroups.length)+1, name:  'ללא קבוצה'});
  }
}
